
import { InsInfo } from '@/modules/aftersales/types/carInfo'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ViewRenewInsurance extends Vue {
  @Prop() insInfo!: InsInfo

  get currentInsurance() {
    const {
      insurance_company_name,
      business_ins_expires_on,
      force_ins_expires_on,
      policy_type,
      insurance_rating,
      last_follow
    } = this.insInfo

    // 续保保险险种列表
    const insuranceItems = (policy_type && policy_type.ins_items) || []
    const hasInsuranceItems = insuranceItems.length > 0 || policy_type.is_select_force

    return {
      ...this.insInfo,
      insuranceItems,
      hasInsuranceItems,
      insurance_company_name: insurance_company_name || '--',
      hasInsurance: business_ins_expires_on && force_ins_expires_on,
      insurance_rating: insurance_rating || '--',
      last_follow: {
        date: last_follow.date || '--',
        content: last_follow.content || '--',
        next_follow_date: last_follow.next_follow_date || '--'
      }
    }
  }
}
